import CollectGraphicsFilterModal from "./collect-graphics-filter-modal";

const CollectGraphicsModals = {
    Filter: CollectGraphicsFilterModal
};

export default CollectGraphicsModals;
